function isEventAtCoordinates(event:any, coordinates:any) {
  if (!event.lngLat) return false;
  return event.lngLat.lng === coordinates[0] && event.lngLat.lat === coordinates[1];
}

export default isEventAtCoordinates;
